import { PropTypes } from "prop-types";

import useCountdownTimer from "@hooks/useCountdownTimer";

export default function CountdownTimer({ hours, minutes, seconds }) {
  const totalSeconds = Number(hours) * 3600 + Number(minutes) * 60 + Number(seconds);

  const timeStr = useCountdownTimer({ countdownSeconds: totalSeconds });

  return (
    <div className="inline-block align-bottom items-center px-[3px] rounded-[1px] typo-body font-bold text-white bg-black">
      {timeStr.split(":").map((t, i) => (
        <span key={i}>
          {t}
          {["h", "m", "s"][i]}
          {i < 2 && " : "}
        </span>
      ))}
    </div>
  );
}

CountdownTimer.propTypes = {
  hours: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  minutes: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  seconds: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
